import { render, staticRenderFns } from "./datum.vue?vue&type=template&id=5fe1c69e&scoped=true&"
import script from "./datum.vue?vue&type=script&lang=js&"
export * from "./datum.vue?vue&type=script&lang=js&"
import style0 from "./datum.vue?vue&type=style&index=0&id=5fe1c69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe1c69e",
  null
  
)

export default component.exports